import swal from 'sweetalert'

class Popup {

    constructor(options) {

        this.options = {
            position: 'top-left',
            className: ''
        }

        if (options) {
            this.options = Object.assign(this.options, options)
        }
    }

    alert(message, successCallback) {

        var options = this.options

        options['closeOnClickOutside'] = false

        options['buttons'] = {
            ok: {
                text: "OK",
                className: 'btn font-opensans text-sm system-button-color system-button-text-color'
            },

            ...options['buttons']
        }

        swal(message, this.options)
            .then(function (value) {

                if (value == 'ok') {

                    if (typeof successCallback == 'function') {
                        return successCallback()
                    }
                }

                return
            })
    }

    confirm(message, successCallback, cancelCallback) {

        var options = this.options

        options['buttons'] = {
            ok: {
                text: "OK",
                className: 'btn font-opensans text-md system-button-color system-button-text-color'
            },
            reject: {
                text: 'Cancel',
                className: 'btn default font-opensans text-md'
            },

            ...options['buttons']
        }

        if (options['customButtons']) {
            options['buttons'] = Object.assign({}, options['buttons'], options['customButtons'])
        }

        swal(message, options)
            .then(function (value) {
                if (!value) {
                    if (options['buttons'].cancel && typeof options['buttons'].cancel.callback === 'function') {
                        options['buttons'].cancel.callback()
                    }

                    swal.close()

                    return
                }

                if (value == 'ok') {
                    if (typeof successCallback == 'function') {
                        return successCallback()
                    }
                }

                if (typeof cancelCallback == 'function') {

                    return cancelCallback()
                }

                return
            })
    }

    close() {
        return swal.close()
    }

    getState() {
        return swal.getState()
    }
}

export default {
    alert(message, successCallback, options) {
        const popup = new Popup(options)
        return popup.alert(message, successCallback)
    },

    confirm(message, successCallback, cancelCallback, options) {
        const popup = new Popup(options)
        return popup.confirm(message, successCallback, cancelCallback)
    },

    close() {
        const popup = new Popup()
        return popup.close()
    },

    getState() {
        const popup = new Popup()
        return popup.getState()
    }
}
